var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useEffect, useState } from 'react';
import { setFilter, filterListener } from './Utils';
import { MultipleSelect } from '../forms';
import { httpClient } from '../services';
import { PopUpMessage } from '../general';
import FilterToggle from './FilterToggle';
import { stopPropagation } from '../general/Utils';
function FilterMultiSelect(props) {
    var attribute = props.attribute, componentId = props.componentId, rename = props.rename, zone = props.zone, setZone = props.setZone, endpoint = props.endpoint, baseUrl = props.baseUrl;
    var _a = useState([]), data = _a[0], setData = _a[1];
    var _b = useState([]), values = _b[0], setValues = _b[1];
    var _c = useState(false), disabled = _c[0], setDisabled = _c[1];
    var _d = useState(false), exists = _d[0], setExists = _d[1];
    var _e = useState(false), negate = _e[0], setNegate = _e[1];
    var _f = useState(null), timeoutValue = _f[0], setTimeoutValue = _f[1];
    var _g = useState(false), loading = _g[0], setLoading = _g[1];
    var _h = useState(false), fetched = _h[0], setFetched = _h[1];
    var _j = useState(''), errorMessage = _j[0], setErrorMessage = _j[1];
    var operator = 'in_list';
    useEffect(function () {
        if (!fetched && values.length !== 0) {
            fetchValues();
        }
    }, [values]);
    var fetchValues = function () {
        if (!fetched) {
            setLoading(true);
            var aggs = { aggs: {} };
            aggs["aggs"][attribute] = { "terms": { "field": "".concat(attribute, ".keyword"), "size": 500 } };
            httpClient().post('/' + endpoint + ':aggregations', aggs, {
                baseURL: baseUrl
            })
                .then(function (res) {
                var aggValues = res.data.meta.aggregations[attribute].buckets;
                setData(aggValues.map(function (item) { return item.key; }));
                setLoading(false);
                setFetched(true);
                updateDropdownText('No results found');
            })
                .catch(function (error) {
                setErrorMessage("Error fetching unique values for " + attribute + " in " +
                    endpoint + ". " + error.message + ".");
                console.error(error.message);
                setLoading(false);
                setFetched(true);
                updateDropdownText('Error fetching values');
            });
        }
    };
    filterListener({
        attribute: attribute,
        componentId: componentId,
        operators: [operator],
        zone: zone,
        setValue: setValues,
        setExists: setExists,
        setNegate: setNegate,
        setDisabled: setDisabled,
        emptyValue: [],
        zoneToValue: function (filterValue) {
            return filterValue;
        }
    }, [zone]);
    var onFilter = function (input) {
        setValues(input);
        var delay = (input.length === 0) ? 0 : 800;
        clearTimeout(timeoutValue);
        setTimeoutValue(setTimeout(function () {
            setFilter({
                operator: operator,
                value: input,
                negate: negate,
                attribute: attribute,
                componentId: componentId,
                zone: zone,
                valueExists: input.length !== 0,
            });
            setZone(__assign({}, zone));
        }, delay));
    };
    var onExists = function (ex) {
        setExists(!ex);
        setValues([]);
        setFilter({
            operator: 'exists',
            negate: negate,
            exists: !ex,
            attribute: attribute,
            componentId: componentId,
            zone: zone
        });
        setZone(__assign({}, zone));
    };
    var onNegate = function (ng) {
        setNegate(!ng);
        setFilter({
            operator: (exists) ? 'exists' : operator,
            value: values,
            negate: !ng,
            exists: exists,
            attribute: attribute,
            componentId: componentId,
            zone: zone,
            valueExists: values.length !== 0
        });
        setZone(__assign({}, zone));
    };
    var updateDropdownText = function (text) {
        var div = document.querySelector('.rs-picker-none');
        if (div)
            div.innerHTML = text;
    };
    var setDropdownText = function () {
        if (!fetched)
            updateDropdownText('Loading values...');
        else if (errorMessage !== '')
            updateDropdownText('Error fetching values');
    };
    return (_jsxs("div", __assign({ className: "tol-multi-filter", onClick: stopPropagation }, { children: [_jsx(PopUpMessage, { type: 'danger', message: errorMessage, setMessage: setErrorMessage }), _jsx(MultipleSelect, { block: true, data: data, placeholder: rename, disabled: disabled, value: values, setValue: onFilter, loading: loading, onEntering: function () { return setDropdownText(); }, onClick: function (e) {
                    e.stopPropagation();
                    fetchValues();
                } }), _jsx(FilterToggle, { negate: negate, onNegate: onNegate, exists: exists, onExists: onExists, disabled: disabled })] })));
}
export default FilterMultiSelect;
